import React, { useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import BlackBack from './BlackBack';
import { clickOutside } from './common';
import Close from '../../assets/icons/Icon';
import { Modal, Icon } from './CustomModal.styled';

const CustomModal = ({
  isBlackBack, width, height, closeModal, closeIcon, render, position,
}) => {
  const ref = useRef(null);

  useEffect(() => clickOutside(ref, closeModal), [ref]);

  return (
    <>
      <BlackBack open={isBlackBack} />
      <Modal width={width} height={height} ref={ref} className="custom-modal" position={position}>
        <Icon onClick={() => closeModal()}>
          {closeIcon && (<Close />)}
        </Icon>
        {render()}
      </Modal>
    </>
  );
};

CustomModal.displayName = 'CustomModal';

export { CustomModal };

CustomModal.defaultProps = {
  isBlackBack: false,
  width: '30vw',
  height: '60vh',
  position: 'inherit',
  closeIcon: false,
};

CustomModal.propTypes = {
  isBlackBack: PropTypes.bool,
  width: PropTypes.string,
  height: PropTypes.string,
  closeModal: PropTypes.func.isRequired,
  closeIcon: PropTypes.bool,
  position: PropTypes.string,
  render: PropTypes.func.isRequired,
};
